export default __webpack_public_path__ + "static/media/myPortfolio.5e88c1a5.png";